import { getToken, setToken, removeToken } from '@/utils/auth'
// import { login, getInfo, logout } from '../../api/userLoginApi'


const getDefaultState = () => {
    return {
        token: getToken(),
        name: '',
        avatar: '',
        pers: []
    }
}

const state = getDefaultState()

const getters = {
    token: state => state.token,
    isAuthenticated: state => !!state.token,
    name: state => state.name,
    avatar: state => state.avatar,
    pers: state => state.pers
}

const mutations = {
    SET_TOKEN(state, token) {
        state.token = token
        state.isAuthenticated = !!token
    },
    CLEAR_AUTH(state) {
        state.token = null
        state.isAuthenticated = false
    },
    RESET_STATE(state) {
        Object.assign(state, getDefaultState())
    },
    SET_USER_INFO(state, { name, avatar, pers }) {
        state.name = name
        state.avatar = avatar
        state.pers = pers
    }
}

const actions = {
    // user login
    // async login({ commit }, { username, password, route }) {
    //     try {
    //         const response = await login({ username: username.trim(), password, route })
    //         const { token } = response.data
    //         commit('SET_TOKEN', token)
    //         setToken(token)
    //     } catch (error) {
    //         throw error
    //     }
    // },
    // get user info
    // async getInfo({ commit, state }) {
    //     if (!state.token) {
    //         throw new Error('Token is null')
    //     }

    //     try {
    //         const response = await getInfo()
    //         const { one } = response.data
    //         if (!one) {
    //             commit('CLEAR_AUTH')
    //             removeToken()
    //             throw new Error('Verification failed, please Login again.')
    //         }

    //         commit('SET_USER_INFO', {
    //             name: one.nickname,
    //             avatar: one.avatar,
    //             pers: one.authorityList
    //         })
    //         return one
    //     } catch (error) {
    //         throw error
    //     }
    // },
    // user logout
    // async logout({ commit }) {
    //     try {
    //         await logout()
    //     } catch (error) {
    //         // 即使 logout 接口失败，也继续清理本地状态
    //         console.warn('logout api failed, proceed with local cleanup', error)
    //     } finally {
    //         removeToken()
    //         commit('RESET_STATE')
    //         commit('CLEAR_AUTH')
    //     }
    // }
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};
